<template>
  <v-main>
    <navigation v-if="!liffUser"/>
    <guide-tour
      :config-key="`care.${$router.currentRoute.name}`"
      :clear-all-subtitle="$router.currentRoute.name === 'careProgressPending'"
    />
    <div class="px-4">
      <dentco-alert-bar
        v-if="$router.currentRoute.name === 'careProgressPending'"
        :message="alertMessage"
        :btn-to="{name: 'CareTemplateList'}"
        btn-title="點我前往 [術後關懷設定] 頁面"
        class="mt-4"
      />
    </div>

    <v-tabs v-model="tab" right>
      <v-tab to="/post-operative-care/progress/unprocessed">待處理</v-tab>
      <v-tab to="/post-operative-care/progress/processed">已處理</v-tab>
      <v-tab to="/post-operative-care/progress/pending">訊息排程管理</v-tab>
    </v-tabs>
    <router-view/>
  </v-main>
</template>

<script>
import Navigation from "@/components/Navigation";
import { mapGetters } from "vuex";
import GuideTour from "@/components/utils/GuideTour.vue";
import DentcoAlertBar from "@/components/utils/DentcoAlertBar.vue";

export default {
  name: "ProgressIndex",
  components: {DentcoAlertBar, GuideTour, Navigation },
  computed: {
    ...mapGetters(["liffUser"]),
    tab: {
      get() {
        // Note: This computed property makes the tab active based on the route.
        const path = this.$route.path;
        if (path.includes('/pending')) return 0;
        if (path.includes('/unprocessed')) return 1;
        if (path.includes('/processed')) return 2;
        return 0;
      },
      set(value) {
        // The <v-tab> "to" prop handles navigation, so setter can be empty.
      }
    },
    alertMessage() {
      return `此頁可調整發送時間，如要調整內容請至設定頁面，有任何問題請 <a target="_blank" href="${this.$enum.DENTCO_CS_LINE}">聯繫客服</a> 。`
    }
  },
};
</script>
